// Background image mapping for different page types
export const backgroundImages = {
  services: ['/cpaservices.jpg'],
  about: ['/whoweare.jpg'],
  contact: ['/cpa.jpg'],
  marketSegments: ['/certified_firm.jpg'],
  attestations: ['/cpaservices.jpg'],
  blog: ['/whoweare.jpg'],
  notFound: ['/cpa.jpg'],
  default: ['/cpaservices.jpg']
}

// Function to get a background image based on page type and optional seed
export const getBackgroundImage = (pageType: keyof typeof backgroundImages, seed?: string): string => {
  const images = backgroundImages[pageType] || backgroundImages.default
  
  if (seed) {
    // Use seed to determine which image to use for consistency
    const index = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % images.length
    return images[index]
  }
  
  // Use random selection if no seed provided
  return images[Math.floor(Math.random() * images.length)]
}

// Function to get background image based on pathname
export const getBackgroundFromPath = (pathname: string): string => {
  let pageType: keyof typeof backgroundImages = 'default'
  
  if (pathname.startsWith('/services')) {
    pageType = 'services'
  } else if (pathname.startsWith('/about')) {
    pageType = 'about'
  } else if (pathname.startsWith('/contact')) {
    pageType = 'contact'
  } else if (pathname.startsWith('/market-segments')) {
    pageType = 'marketSegments'
  } else if (pathname.startsWith('/attestations')) {
    pageType = 'attestations'
  } else if (pathname.startsWith('/blog')) {
    pageType = 'blog'
  } else if (pathname === '/404' || pathname.includes('not-found')) {
    pageType = 'notFound'
  }
  
  return getBackgroundImage(pageType, pathname)
}